import axios from "axios";
import {
  getUnitApiBaseFour,
  SUB_URL,
  SUB_URL_GSM,
  SUB_URL_wash,
} from "../BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) {
    throw new Error("unit_code missing");
  }
  return unitCode;
};

const BinLocationService = {
  BinOutward: async (bin_id, addedBy) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("bin_id", bin_id || "");
      formData.append("added_by", addedBy || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_wash.washing}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in BinOutward:", error);
      return {
        status: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to move bin outward",
        data: [],
      };
    }
  },

  BinInward: async (bin_id, addedBy) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("bin_id", bin_id || "");
      formData.append("received_by", addedBy || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_wash.in_ward}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in BinInward:", error);
      return {
        status: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to move bin inward",
        data: [],
      };
    }
  },

  WashingBin: async (bin_id, addedBy) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("bin_id", bin_id || "");
      formData.append("added_by", addedBy || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_wash.outward}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in WashingBin:", error);
      return {
        status: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to process washing bin",
        data: [],
      };
    }
  },

  BinOutwardWash: async (bin_id, addedBy) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("bin_id", bin_id || "");
      formData.append("added_by", addedBy || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_wash.outward}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in BinOutwardWash:", error);
      return {
        status: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to move wash bin outward",
        data: [],
      };
    }
  },

  GSM_inward: async (bin_id, addedBy) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("bin_id", bin_id || "");
      formData.append("received_by", addedBy || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_GSM.GSM_inward}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in GSM_inward:", error);
      return {
        status: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to inward GSM bin",
        data: [],
      };
    }
  },

  GSM_outward: async (bin_id, addedBy) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("bin_id", bin_id || "");
      formData.append("received_by", addedBy || "");
      formData.append("added_by", addedBy || "");



      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_GSM.GSM_outward}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in GSM_outward:", error);
      return {
        status: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to outward GSM bin",
        data: [],
      };
    }
  },

  sendKanbanFinish: async (bin_id, addedBy) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("kb_number", bin_id || "");
      formData.append("cleared_by", addedBy || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.Kanban_Count_accuracy}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error in sendKanbanFinish:", error);
      return {
        status: false,
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to send kanban finish",
        data: [],
      };
    }
  },

  bulk_bin_movement: async (
  formatedBinId,
  addedBy,
  from_location,
  to_location,
  api_type
) => {
  try {
    const unitCode = getUnitCode();

    const formData = new FormData();
    formData.append("bin_ids", JSON.stringify(formatedBinId || []));
    formData.append("added_by", addedBy || "");
    formData.append("from_location", from_location || "");
    formData.append("to_location", to_location || "");
    formData.append("api_type", api_type || "");

    const response = await axios.post(
      `${getUnitApiBaseFour(unitCode)}${SUB_URL.bulk_bin_movement}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error in bulk_bin_movement:", error);
    return {
      status: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to process bulk bin movement",
      data: [],
    };
  }
},

garment_supermarket_bulk_inward: async (formatedBinId, addedBy) => {
  try {
    const unitCode = getUnitCode();

    const formData = new FormData();
    formData.append("bin_ids", JSON.stringify(formatedBinId || []));
    formData.append("received_by", addedBy || "");

    const response = await axios.post(
      `${getUnitApiBaseFour(unitCode)}${SUB_URL.garment_supermarket_bulk_inward}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error in garment_supermarket_bulk_inward:", error);
    return {
      status: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to inward garment supermarket bins",
      data: [],
    };
  }
},
};

export default BinLocationService;